/* istanbul ignore file */
import type { FragmentType } from '@packages/gql/generated/shopping';
import type { CategoryRecommendationFragmentFragmentDoc } from '@packages/gql/generated/shopping/CategoryRecommendationFragmentFragmentDoc';
import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';
import type { GTMEventGlycerinDisplayRecommendation } from '@packages/tracking/src/types/events';
import { useEffect } from 'react';
import { getCategoryGlycerinTiles } from '../../helpers/getCategoryGlycerinTiles';
import type { RdeType } from '../../types';

type TrackingProps = {
  rdeTypeAbbr?: string;
  rdeType: RdeType;
  recommendations?: Array<FragmentType<typeof CategoryRecommendationFragmentFragmentDoc>>;
  title: string;
  trackingCondition: boolean;
};

export const useCategoriesRecoTracking = ({
  rdeType,
  rdeTypeAbbr,
  recommendations,
  title,
  trackingCondition,
}: TrackingProps) => {
  const dispatchGTMEvent = useTracking();

  useEffect(() => {
    if (trackingCondition && rdeTypeAbbr && recommendations !== undefined) {
      // glycerin seen tracking
      dispatchGTMEvent<GTMEventGlycerinDisplayRecommendation>({
        event: 'DisplayRecommendation',
        DisplayRecommendationData: {
          name: title,
          // TODO: add placement as prop in trackingProps -> https://empiriecom.atlassian.net/browse/INFORM-2616
          // placement: GlycerinPlacement.CONTENT,
          recoId: rdeTypeAbbr,
          recoType: 'carousel',
          strategy: rdeType,
          tiles: getCategoryGlycerinTiles(recommendations),
          totalSize: recommendations.length,
        },
      });
    }
  }, [dispatchGTMEvent, rdeType, rdeTypeAbbr, recommendations, title, trackingCondition]);
};
